// Exports the "colorpicker" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/colorpicker')
//   ES2015:
//     import 'tinymce/plugins/colorpicker'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ../~/tinymce/plugins/colorpicker/index.js
// module id = 541
// module chunks = 0